import { render } from "./AdminsEditing.vue?vue&type=template&id=18e15cf8&ts=true"
import script from "./AdminsEditing.vue?vue&type=script&lang=ts"
export * from "./AdminsEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__